<template>
	<div class="flex flex-col bg-slate-100">
		<div class="fixed top-safe left-safe right-safe flex items-center py-4 px-5 bg-white shadow-sm">
			<BaseIcon
				name="arrow-long-left"
				class="w-9 h-9 p-1.5 rounded-full -ms-1.5 text-primary bg-primary bg-opacity-0 hover:bg-opacity-10 duration-300 cursor-pointer transform rtl:-scale-x-100"
				@click="$backWithFallback($routeUrl.StartUrl())"
			/>
			<div class="flex-grow" />
			<NuxtLink :to="$routeUrl.StartUrl()">
				<img src="/img/app-logo.png" alt="" class="h-8 w-auto" />
			</NuxtLink>
		</div>
		<div class="flex flex-col items-center px-6 pt-32 pb-16 flex-grow">
			<main class="flex flex-col w-full max-w-screen-lg prose prose-sm md:prose-lg lg:prose-xl prose-slate">
				<ContentDoc />
			</main>
		</div>
	</div>
</template>